<template>
  <b-alert show variant="primary" style="padding:0.5em; margin:0.5em;">
    <h3>Thank you</h3>
    <hr>
    <h5>You have successfully logged in to the symptom reporting system.

      <br>
      <br>
      We're waiting for the researcher to link you to ORBITA-2.
      <br>
    </h5>
  </b-alert>
</template>

<script>
export default {};
</script>

<style>
</style>





// WEBPACK FOOTER //
// src/components/AppAwaitingApproval.vue